var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 2C4 3.10449 3.10547 4 2 4C0.894531 4 0 3.10449 0 2C0 0.895508 0.894531 0 2 0C3.10547 0 4 0.895508 4 2Z",
    fill: "#44546F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33789 3.48706C8.98242 3.80591 8.51367 4 8 4C6.89453 4 6 3.10449 6 2C6 0.895508 6.89453 0 8 0C8.48633 0 8.93164 0.172852 9.27734 0.460449C9.71875 0.827393 10 1.38086 10 2C10 2.59033 9.74414 3.12109 9.33789 3.48706Z",
    fill: "#44546F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 4C15.1055 4 16 3.10449 16 2C16 0.895508 15.1055 0 14 0C12.8945 0 12 0.895508 12 2C12 3.10449 12.8945 4 14 4Z",
    fill: "#44546F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.084 9.68164C14.7715 9.88306 14.4004 10 14 10C12.8945 10 12 9.10449 12 8C12 6.89551 12.8945 6 14 6C15.1055 6 16 6.89551 16 8C16 8.26245 15.9492 8.51294 15.8574 8.74243C15.7031 9.13013 15.4316 9.45801 15.084 9.68164Z",
    fill: "#44546F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10C9.10547 10 10 9.10449 10 8C10 7.48462 9.80469 7.01465 9.48438 6.65991C9.11914 6.25464 8.58984 6 8 6C6.89453 6 6 6.89551 6 8C6 9.10449 6.89453 10 8 10Z",
    fill: "#44546F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 8.54614 3.78125 9.04126 3.42773 9.40234C3.06445 9.77124 2.55859 10 2 10C0.894531 10 0 9.10449 0 8C0 7.13208 0.552734 6.39307 1.32617 6.11646C1.39062 6.09326 1.45703 6.07324 1.52539 6.05664C1.63672 6.02954 1.75 6.01196 1.86719 6.00439L2 6C3.10547 6 4 6.89551 4 8Z",
    fill: "#44546F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 16C3.10547 16 4 15.1045 4 14C4 12.8955 3.10547 12 2 12C0.894531 12 0 12.8955 0 14C0 15.1045 0.894531 16 2 16Z",
    fill: "#44546F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14C10 14.3623 9.9043 14.7021 9.73633 14.9951C9.39062 15.5955 8.74219 16 8 16C6.89453 16 6 15.1045 6 14C6 12.8955 6.89453 12 8 12C9.10547 12 10 12.8955 10 14Z",
    fill: "#44546F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16C15.1055 16 16 15.1045 16 14C16 13.3132 15.6543 12.7075 15.127 12.3474C14.8066 12.1282 14.418 12 14 12C12.8945 12 12 12.8955 12 14C12 15.1045 12.8945 16 14 16Z",
    fill: "#44546F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopMenu);
export default __webpack_public_path__ + "static/media/top-menu.93dc07686041b2a02f86eb120dbd088c.svg";
export { ForwardRef as ReactComponent };